// extracted by mini-css-extract-plugin
module.exports = {"container":"Ti","copy":"Ui","m-heart-activate":"Vi","bottomSection":"Wi","signInButton":"Xi","disabled":"Yi","m-heart-pulse":"Zi"};